export const environment = {
  production: false,
  blogApiUrl: 'https://dev.blog.dwall.online/api',
  hmr: false,
  type: 'dev',
  urlAppRedirect: 'https://dev.app.dwall.online/v2',
  registerLink: 'https://dev.app.dwall.online/v2/authentication/register',
  appDomain: 'https://dev.app.dwall.online'
};
